module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_3.77957ada.png";